import juice from 'juice';
import React from 'react';
import { renderToString } from 'react-dom/server';

import { TBlock, TTemplate } from '@wp-block-builder/package';
import { WaypointDocumentStoreProvider } from '@wp-block-builder/stores/WaypointDocumentStore';

type Props = {
  block: Extract<TBlock, { type: 'LoopContainer' }>;
  BlockComponent: (props: { block: TBlock }) => JSX.Element;
  configuration: TTemplate;
};
export default function getLoopRawLiquidBlock({ block, configuration, BlockComponent }: Props) {
  const blocks = block.props?.blocks ?? [];
  return [
    `{% for ${block.props?.loopArgumentName} in ${block.props?.loopTemplate} %}`,
    `{% assign ${block.props?.loopIndexName} = forloop.index %}`,
    juice(
      renderToString(
        <WaypointDocumentStoreProvider variables={{}} skipLiquid configuration={configuration}>
          {blocks.map((block, i) => (
            <BlockComponent key={i} block={block} />
          ))}
        </WaypointDocumentStoreProvider>
      )
    ),
    `{% endfor %}`,
    null,
  ].join('\n');
}
